// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-gtKC6";
var _3 = "text-15EwQ";
var _4 = "button-G_y6o";
export { _1 as "__esModule", _2 as "wrapper", _3 as "text", _4 as "button" }
export default { "__esModule": _1, "wrapper": _2, "text": _3, "button": _4 }
